/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/camelcase */

// libraries
import React, { useCallback, useMemo } from 'react';

// custom components
import ClientSignUpForm from './components/ClientSignUpForm';

// services
import { convertClientValuesToDataModel } from './services';

// api
import api from '../api';

// constants
import { UserRoles } from 'constants/user';

//hooks
import useConvertedProviderCriteria from 'hooks/useConvertedProviderCriteria';

// utils
import { VALIDATION_TYPES } from 'utils/validation/types';
import { validate } from 'utils/validation';

const ClientSignUpContainer = ({ termsOfUse, privacyPolicy }: any): JSX.Element => {
  const { serviceOptions, stageOptions } = useConvertedProviderCriteria(true);

  const handleSubmit = useCallback(
    async (values: any) => {
      const convertedValues = convertClientValuesToDataModel(
        {
          ...values,
          termsAccepted: true,
        },
        termsOfUse,
        privacyPolicy,
      );
      await api.postSignUp(UserRoles.CLIENT, convertedValues);
      // @ts-ignore
      gtag('event', 'Client Sign Up Form Finish', {
        event_category: 'Footer',
        event_label: 'Form Submit',
      });
    },
    [termsOfUse, privacyPolicy],
  );

  const validationSchema = useMemo(
    () => ({
      firstName: {
        [VALIDATION_TYPES.REQUIRED]: true,
      },
      lastName: {
        [VALIDATION_TYPES.REQUIRED]: true,
      },
      email: {
        [VALIDATION_TYPES.REQUIRED]: true,
        [VALIDATION_TYPES.EMAIL]: true,
      },
    }),
    [],
  );

  const formValidation = useCallback((values: any) => validate(values, validationSchema), [validationSchema]);
  const handleAnalytics = useCallback((dirty: any) => {
    if (Object.values(dirty.dirtyFields).length === 1) {
      // @ts-ignore
      gtag('event', 'Client Sign Up Form Start', {
        event_category: 'Footer',
        event_label: 'Form Fill',
      });
    }
  }, []);

  return (
    <ClientSignUpForm
      onSubmit={handleSubmit}
      stageOptions={stageOptions}
      serviceOptions={serviceOptions}
      formValidation={formValidation}
      handleAnalytics={handleAnalytics}
    />
  );
};

export default ClientSignUpContainer;
